import { Box, Typography, styled, CircularProgress } from "@mui/material";
import { FormTextInput } from "@/components/custom/custom-form-text-input";
import { CustomButton } from "@/components/custom/custom-button";

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),

  [theme.breakpoints.up("lg")]: {
    flexDirection: "row",
  },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,

  [theme.breakpoints.up("lg")]: {
    width: 256,
  },
}));

const Content = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Grid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),

  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "1fr 1fr",
  },
}));

export const ChangePassword = ({ formik, isDisabled }) => {
  return (
    <Wrapper>
      <Row>
        <Side>
          <Typography fontWeight={500} fontSize={18}>
            Change Password
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Update your password here.
          </Typography>
        </Side>

        <Content>
          <Grid>
            <FormTextInput
              formik={formik}
              name="oldPassword"
              label="Old Password"
              isDisabled={isDisabled}
              type="password"
            />

            <FormTextInput
              formik={formik}
              name="newPassword"
              label="New Password"
              isDisabled={isDisabled}
              type="password"
            />
          </Grid>

          <Box display="flex" justifyContent="flex-end">
            <CustomButton
              type="submit"
              variantType="outline"
              size="small"
              disabled={isDisabled || !formik.isValid || !formik.dirty}
              sx={{
                minWidth: 140,
                px: 2,
              }}
            >
              {isDisabled ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <CircularProgress size={16} thickness={5} />
                  Saving...
                </Box>
              ) : (
                "Save Changes"
              )}
            </CustomButton>
          </Box>
        </Content>
      </Row>
    </Wrapper>
  );
};
